import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../Api/auth";


const PrivateRoute = ({ component: Component, type, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated() ? (
                <Component {...props} type={type} />
            ) : (
                // <Component {...props} type={type} />
                <Redirect
                    to={{
                        pathname: "/",
                        state: { from: props.location, message: "can not access without login" }
                    }}
                />
            )}
    />
);

export default PrivateRoute;